import internalEvents from './internalEvents';
// This module is allowing the widget to determine it's own styling
// based off of how wide it's needing to be
//
var interval = null;
var widgetStyle = function (wrapper, config) {
    // Determine the correct styling
    var process = function (dom) {
        var _a, _b, _c, _d;
        var width = dom === null || dom === void 0 ? void 0 : dom.offsetWidth;
        if (width === 0) {
            return false;
        }
        var compactSize = (_b = (_a = config.variantSizes) === null || _a === void 0 ? void 0 : _a.compact) !== null && _b !== void 0 ? _b : 600;
        var contentSize = (_d = (_c = config.variantSizes) === null || _c === void 0 ? void 0 : _c.content) !== null && _d !== void 0 ? _d : 1000;
        var variant = config.baseStyle
            ? config.baseStyle
            : width < compactSize
                ? 'compact'
                : width < contentSize
                    ? 'content'
                    : 'fullscreen';
        if (variant && dom) {
            // Defensively reset DOM
            var domClassList = dom.classList;
            if (domClassList.contains('compact') && variant !== 'compact') {
                domClassList.remove('compact');
            }
            if (domClassList.contains('content') && variant !== 'content') {
                domClassList.remove('content');
            }
            if (domClassList.contains('fullscreen') && variant !== 'fullscreen') {
                domClassList.remove('fullscreen');
            }
            // set new style
            if (!domClassList.contains(variant)) {
                domClassList.add(variant);
            }
        }
        if (config.sizeVariant !== variant) {
            if (internalEvents) {
                var events = internalEvents(config);
                events.emit('resize', variant);
            }
            // Configuration is up-to-date with which variant is on.
            config.sizeVariant = variant;
        }
    };
    // Initial trigger
    process(wrapper);
    // Some elements don't render initially, such as rememberMe
    // Have a process to wait for the render to happen.
    if ((wrapper === null || wrapper === void 0 ? void 0 : wrapper.offsetWidth) <= 0) {
        clearInterval(interval);
        interval = setInterval(function () {
            if (wrapper.offsetWidth > 0) {
                clearInterval(interval);
                process(wrapper);
            }
        }, 25);
    }
    // If the style is not hard set, make it dynamic based on size and responsiveness
    if (!(config === null || config === void 0 ? void 0 : config.baseStyle)) {
        var buffer_1;
        var handleResize = function () {
            clearTimeout(buffer_1);
            buffer_1 = setTimeout(function () {
                process(wrapper);
            }, 100);
        };
        window.removeEventListener('resize', handleResize);
        window.addEventListener('resize', handleResize);
    }
};
export default widgetStyle;
